export default __webpack_public_path__ + "943ef86d460bc66e96075ecc50fd1334.png";